import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Dashboard")
  },
  {
    path: "/campaigns",
    name: "CampaignsList",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Campaigns/List")
  },
  {
    path: "/campaigns/:campaignId/draft",
    name: "CampaignsDraft",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Campaigns/Edit")
  },
  {
    path: "/campaigns/:campaignId/edit",
    name: "CampaignsEdit",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Campaigns/Edit")
  },
  {
    path: "/campaigns/:campaignId/view",
    name: "CampaignsView",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Campaigns/View")
  },
  {
    path: "/campaigns/:campaignId/messages",
    name: "CampaignsMessages",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/campaigns/:campaignId/clicks",
    name: "CampaignsClicks",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/campaigns/:campaignId/conversions",
    name: "CampaignsConversions",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/automations",
    name: "Automations",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Automations")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Settings")
  },
  {
    path: "/reports/messages",
    name: "ReportMessages",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/reports/clicks",
    name: "ReportClicks",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/reports/conversions",
    name: "ReportConversions",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/reports/stream",
    name: "ReportStream",
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ "../views/Reports")
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () =>
      import(/* webpackChunkName: "Onboarding" */ "../views/Onboarding")
  },
  {
    path: "/error",
    name: "Error",
    component: () => import(/* webpackChunkName: "Error" */ "../views/Error")
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import(/* webpackChunkName: "Error" */ "../views/Error")
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
